import { ITableAdapter } from '../../../../../../generic/universal-table/types/adapter.types'
import {
  ProductApiRow,
  ProductCreatePayload,
  ProductUiRow,
  ProductUpdatePayload,
} from '../types/productTable.types'

// API already returns proper booleans; we only need to trim string whitespace.
export const productTableAdapter: ITableAdapter<
  ProductApiRow,
  ProductUiRow,
  ProductCreatePayload,
  ProductUpdatePayload
> = {
  fromApi: (row: ProductApiRow): ProductUiRow => ({
    ProductID: row.ProductID,
    ProductDesc: row.ProductDesc?.trim() ?? '',
    GeneralProductID: row.GeneralProductID ?? 0,
    ProductDescEng: row.ProductDescEng?.trim() ?? '',
    VAT: row.VAT ?? false,
    CollectorSort: row.CollectorSort ?? 0,
    CalculationMethod: row.CalculationMethod ?? 0,
    Active: row.Active ?? false,
    CollectDeviation: row.CollectDeviation ?? 0,
    WastePercent: row.WastePercent ?? 0,
    PriseListSort: row.PriseListSort ?? 0,
    NoTagCollection: row.NoTagCollection ?? false,
    ProductFamilyId: row.ProductFamilyId ?? 0,
    AccountId: row.AccountId ?? 0,
    PrintProductDesc: row.PrintProductDesc?.trim() ?? '',
    PrintProductDesc_CLASS2: row.PrintProductDesc_CLASS2?.trim() ?? '',
    MandatoryWeight: row.MandatoryWeight ?? false,
    ActivityType: row.ActivityType ?? 0,
    Item_For_Stock: row.Item_For_Stock ?? false,
    ExternalNumber: row.ExternalNumber?.trim() ?? '',
  }),

  toCreatePayload: ({
    ProductID: _,
    ...rest
  }: ProductUiRow): ProductCreatePayload => rest,

  toUpdatePayload: ({
    ProductID: _,
    ...rest
  }: ProductUiRow): ProductUpdatePayload => rest,

  getRowId: (row: ProductUiRow): number => row.ProductID,
}
